/**
 * Resource-link target types with registered frontend adapters.
 */
export const RESOURCE_LINK_TARGETS = ['location'] as const

/**
 * A resource-link target type supported by the frontend adapter registry.
 */
export type ResourceLinkTargetType = (typeof RESOURCE_LINK_TARGETS)[number]

/**
 * Configuration identifying the target resource type of a relation property.
 */
export interface IResourceLinkConfig {
  readonly targetResourceType?: string | null
}

/**
 * Minimal property configuration containing a resource-link target.
 */
export interface IResourceLinkConfiguration {
  readonly resourceLink?: IResourceLinkConfig | null
}

/**
 * Default target used when authoring an inline resource-link property.
 */
export const DEFAULT_RESOURCE_LINK_TARGET: ResourceLinkTargetType = 'location'

/**
 * Parses a configured target into a target supported by frontend adapters.
 */
export const getResourceLinkTargetType = (
  configuration?: IResourceLinkConfiguration | null,
): ResourceLinkTargetType | undefined => {
  const configuredTarget = configuration?.resourceLink?.targetResourceType
  return RESOURCE_LINK_TARGETS.find(target => target === configuredTarget)
}
